import { OfferStatus } from '@/api/v2/requests/offers';

export const OFFER_STATUS_MAP = {
  ACTIVE: 'active',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  FINISHED: 'finished',
  ACCEPTED: 'accepted',
};

export const OFFER_STATUS_COLORS = {
  [OfferStatus.ACTIVE]: 'bg-green',
  [OfferStatus.APPROVED]: 'bg-green',
  [OfferStatus.REJECTED]: 'bg-red',
  [OfferStatus.CONTRACT]: 'bg-red',
  [OfferStatus.FINISHED]: 'bg-blue-dark',
};
